import { render, staticRenderFns } from "./EditBothCard.vue?vue&type=template&id=4fe958bc"
import script from "./EditBothCard.vue?vue&type=script&lang=js"
export * from "./EditBothCard.vue?vue&type=script&lang=js"
import style0 from "./EditBothCard.vue?vue&type=style&index=0&id=4fe958bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports